<template>
    <div>
        <h3 class="ta-center">选择取消原因</h3>
        <k-radio-group v-model="cancelType" @change="change">
            <k-cell v-for="(item,index) in replyList" :key="index"><k-radio :name="index" checked-color="#CEA065">{{item}}</k-radio></k-cell>
        </k-radio-group>
        <k-cell>
            <k-button type="primary" block :disabled="!reply" @click="submit">确认取消订单</k-button>
        </k-cell>
    </div>
</template>

<script>
    import {mapActions} from "vuex"
    export default {
        name: "cancel-order",
        props : ["orderId"],
        data(){
            return {
                cancelType : null,
                replyList: ["藏品鉴定选择与老师专业不符","藏品图片或视频模糊，无法做出判断","订单不符合玄商鉴定规则，请规范提交鉴定资料"],
                reply : null,
                id : this.$route.query.orderId
            }
        },
        methods : {
            ...mapActions("jianding", ["orderCancel"]),
            change(index){
                this.cancelType = index;
                this.reply = this.replyList[index];
                //this.$emit("success", {select : name});
                console.log(index)
            },
            async submit(){
                let {reply, id} = this;
                if(!id) {
                    this.$toast("订单ID有误！");
                    return
                }
                if(!this.reply){
                    this.$toast("请选择取消原因！");
                    return
                }
                await this.orderCancel({reply, id}).then(R => {
                    this.$toast.success("取消成功");
                    this.$router.push({
                        path : "/appraiser/order"
                    });
                }).catch(err => {
                    this.$toast.fail(err.message);
                });

            }
        }
    }
</script>

<style scoped>

</style>